import React, { useMemo } from "react";
import { HStack, Icon, Progress, Tooltip } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { ElectricIcon } from "../../common/icons";

/**
 * Renders the fuel type card
 * 
 * @param {Object} props The props of the component
 * @returns The fuel type card
 */
const FuelTypeCard = ({ vehicle }) => {
  const { t } = useTranslation();
  const vehicleFuelType = useMemo(() => {
    let isElectric = false;
    let isGas = false;

    if (vehicle?.Vehicle?.Powertrain?.TractionBattery?.Charging?.Range) {
      isElectric = true;
    }
    if (vehicle?.Vehicle?.Powertrain?.FuelSystem?.Range) {
      isGas = true;
    }
    return isElectric && isGas ? "hybrid" : isElectric ? "electric" : "gas";
  }, [vehicle?.Vehicle?.Powertrain]);

  return (
    <Tooltip
      hasArrow={true}
      label={t("plugin.tooltips.engine", {
        engine: t(`plugin.tooltips.engineType.${vehicleFuelType}`),
      })}
      placement={"right"}
    >
      <HStack flexGrow={1} alignItems={"center"} justifyContent={"center"} gap={"5px"}>
        <Icon as={ElectricIcon} />
        <Progress flexGrow={1} size={"xs"} borderRadius={"full"} backgroundColor={"#B8BCBD"} colorScheme={"whiteAlpha"} value={50} />
      </HStack>
    </Tooltip>
  );
};

export default React.memo(FuelTypeCard);
